import { useState, useCallback, useEffect } from "react";
import leaveRecallService from "../services/leaveRecallService";

export const useLeaveRecall = ({ employeePersonalInformationId, showGeneralMessage }) => {
  const [loading, setLoading] = useState(false);
  const [recallableData, setRecallableData] = useState([]);
  const [recallHistory, setRecallHistory] = useState([]);

  const fetchRecallData = useCallback(async () => {
    if (!employeePersonalInformationId) return;
    try {
      setLoading(true);
      const [recallableRes, historyRes] = await Promise.all([
        leaveRecallService.getRecallableByEmployee(employeePersonalInformationId),
        leaveRecallService.getRecallHistory(employeePersonalInformationId)
      ]);
      setRecallableData(recallableRes.data || []);
      setRecallHistory(historyRes.data || []);
    } catch (err) {
      console.error("Recall Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  }, [employeePersonalInformationId]);

  useEffect(() => {
    fetchRecallData();
  }, [fetchRecallData]);

  // MODIFIED: Accepts dates object alongside leaveRequestId and reason
  const submitRecall = async (leaveRequestId, reason, dates = {}) => {
    if (!leaveRequestId) return false;

    try {
      setLoading(true);
      const payload = {
        leaveRequestId: leaveRequestId,
        reason: reason,
        employeePersonalInformationId: employeePersonalInformationId,
        recallableDateFrom: dates.recallableDateFrom,
        recallableDateTo: dates.recallableDateTo
      };

      await leaveRecallService.createRecall(payload);
      showGeneralMessage("Leave recall request submitted successfully!", true);
      await fetchRecallData(); // Refresh list after creation
      return true;
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to submit recall request";
      showGeneralMessage(errorMsg, false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    recallableData,
    recallHistory,
    submitRecall,
    refresh: fetchRecallData
  };
};